import BaseIncomingPayload from "./base-incoming-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class V1GroupRestaurantsChosen extends BaseIncomingPayload {
  public readonly payload: V1GroupRestaurantsChosenPayload;

  constructor(payload: Record<string, unknown>) {
    super(payload, IncomingPayloadEvent.V1_GROUP_RESTAURANTS_CHOSEN);

    this.payload = new V1GroupRestaurantsChosenPayload(ParseUtils.parseObject(payload, "payload"));
  }
}

export class V1GroupRestaurantsChosenPayload {
  public readonly group_id: string;
  public readonly user_id: string;

  constructor(payload: Record<string, unknown>) {
    this.group_id = ParseUtils.parseString(payload, "group_id");
    this.user_id = ParseUtils.parseString(payload, "user_id");
  }
}
